import { render, staticRenderFns } from "./WhiteBoard.vue?vue&type=template&id=98ee40f8"
import script from "./WhiteBoard.vue?vue&type=script&lang=js"
export * from "./WhiteBoard.vue?vue&type=script&lang=js"
import style0 from "./WhiteBoard.vue?vue&type=style&index=0&id=98ee40f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports